module.exports = __webpack_public_path__ + "static/img/ro.18358326.svg";